import { useAlert } from '@orientaction/hooks';
import { updateUserInfoInLS } from '@orientaction/utils';
import { pick } from 'lodash';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { apiServiceNative } from '../../../../../utils/fetchNative';
import { IAddress } from '@orientaction/components/PlacesAutocomplete/types';

type UseRecrutementFormParams = {
  user: Record<string, any>;
  onClose: () => void;
  getUser?: () => void;
  idEbook?: string | number;
};

export const useRecrutementForm = ({ user, onClose, getUser, idEbook }: UseRecrutementFormParams) => {
  const [placeValue, setPlaceValue] = useState(user?.town);
  const alert = useAlert();
  const history = useHistory();

  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm<any>({
    mode: 'onChange',
  });

  const onPlaceChange = (address?: IAddress) => {
    if (address?.addressCity) {
      setPlaceValue(address.addressCity);
    } else {
      setPlaceValue('');
    }
  };

  const onSubmitHandler = async (data: Record<string, any>) => {
    try {
      const response = await apiServiceNative.put(`/api/users/${user.id}`, {
        ...data,
        town: placeValue,
      });
      if (response?.id) {
        updateUserInfoInLS(
          pick(response, [
            'town',
            'postal_code',
            'dayOfBirth',
            'gender',
            'streetName',
            'streetNumber',
            'phone',
            'yearExperiences',
            'poste',
            'noticeDeparture',
            'diploma',
          ])
        );
        onClose();
        if (idEbook) {
          history.push(`/ebook-recrutement/${idEbook}/${false}/1`);
        }
        if (getUser) {
          getUser();
        }
      }
    } catch (e) {
      console.error(e);
      alert.setOpenAlert(true, 'Une erreur est survenue, merci de réessayer plus tard', 'error');
    }
  };

  return {
    control,
    errors,
    isValid,
    handleSubmit,
    onSubmitHandler,
    placeValue,
    setPlaceValue,
    onPlaceChange,
  };
};
